import { FlexAlignCenter } from 'components/primitives/flex';
import { mediaSmMax } from 'helpers/breakpoints';
import styled from 'styled-components';

interface Props {
  rating: number | string;
  count: number | string;
  customText?: string;
  isHorizontalCard?: boolean;
  isTopOwner?: boolean;
  className?: string;
}

const StarRating = ({ rating, count, customText, isHorizontalCard, isTopOwner, className }: Props) => (
  <Wrapper
    className={`${isHorizontalCard ? 'starRatingHorizontalCard' : ''} ${
      !isTopOwner && isHorizontalCard ? 'isNotTopOwner' : ''
    } ${className ?? ''}`}
  >
    <StarRatingIcon>
      <Star color={!rating ? '#AAAAAA' : '#72D4BA'} />
    </StarRatingIcon>
    <StarRatingText hasRating={!!rating}>{rating ? `${rating} ` : 'NO REVIEWS'} </StarRatingText>
    {count ? (
      <StarRatingTextRight>{`(${count})`}</StarRatingTextRight>
    ) : (
      <StarRatingText>&nbsp;{rating ? customText || 'ratings' : ''} </StarRatingText>
    )}
  </Wrapper>
);

const Star = ({ color = '#72D4BA' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13">
    <path
      fill={color}
      fillRule="evenodd"
      d="M6.348 10.164a.6.6 0 00-.696 0L3.049 12.02a.6.6 0 01-.927-.648l.901-3.275a.6.6 0 00-.199-.624L.235 5.357a.6.6 0 01.36-1.064l3.216-.11a.6.6 0 00.547-.404L5.433.652a.6.6 0 011.134 0l1.075 3.127a.6.6 0 00.547.404l3.216.11a.6.6 0 01.36 1.064l-2.59 2.116a.6.6 0 00-.198.624l.901 3.275a.6.6 0 01-.927.648l-2.603-1.856z"
      clipRule="evenodd"
    />
  </svg>
);

export default StarRating;

const Wrapper = styled(FlexAlignCenter)`
  &.starRatingHorizontalCard {
    align-self: flex-start;
    min-width: 145px;
    margin-left: 30px;
    justify-content: right;
  }
  &.isNotTopOwner {
    margin-top: -30px;
    overflow: unset;
  }
`;

const StarRatingIcon = styled(FlexAlignCenter)`
  margin: 0 7px 0 0;
  @media ${mediaSmMax} {
    margin-bottom: 2px;
  }
  svg {
    width: 14px;
    height: 14px;
  }
`;

const StarRatingText = styled.span<{ hasRating?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.25;
  color: ${(props) => (props.hasRating ? '#17233c' : '#aaaaaa')};
  font-weight: 600;
  @media ${mediaSmMax} {
    font-size: 10px;
  }
`;

const StarRatingTextRight = styled(StarRatingText)`
  color: #91999a;
  margin-left: 5px;
  font-weight: 500;
`;
